<template>
    <div v-if="botResultData.bot">
        <div class="flex flex-row">
            <div class="w-full">
                <Card>
                    <template #content>
                        <div class="flex flex-row justify-content-between mb-2">
                            <div class="text-xl mb-2">Сделки</div>
                            <div v-if="isShowAllLogs === false">
                                <Button @click="isShowAllLogs = true">Показать все логи ({{countLogs}})</Button>
                            </div>
                            <div v-else>
                                <Button @click="isShowAllLogs = false">Скрыть все логи</Button>
                            </div>
                            <!--                            <a target="_blank" :href="'/replay_chart/'+replayResultId+'/'+botReplayData.bot.name">Chart</a>-->
                        </div>
                        <div v-if="allDeals && allDeals.length > 0" class="flex flex-row">
                            <div class="flex-1">
                            <DataTable :value="allDeals" selectionMode="single" dataKey="token" :expandedRows.sync="expandedDeals" @row-expand="onDealExpand">
                                <Column :expander="true" :headerStyle="{'width': '3rem'}" />
                                <Column header="" field="token" ></Column>
                                <Column header="Покупка" >
                                    <template #body="slotProps">
                                        {{short_timezoned(slotProps.data.started_at)}}
                                    </template>
                                </Column>
                                <Column header="Причина" field="start_reason" ></Column>
                                <!--                                <Column header="Курс" field="rate_started" ></Column>-->
                                <Column header="USDT" field="value_amount_started" ></Column>
                                <Column header="Продано (GMT+3)" >
                                    <template #body="slotProps">
                                        <span v-if="slotProps.data.completed_at">{{short_timezoned(slotProps.data.completed_at)}}</span>
                                    </template>
                                </Column>
                                <Column header="Длительность" field="open_minutes" ></Column>
                                <Column header="Причина" field="complete_reason" ></Column>
                                <!--                                <Column header="Курс" field="rate_completed" ></Column>-->
                                <Column header="%" field="percent_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.percent_profit">
                                            <div v-if="slotProps.data.percent_profit < 1" v-html="round_red(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                            <div v-else v-html="round_green(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                        </div>
                                    </template>
                                </Column>
                                <Column header="Профит" field="value_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.value_profit">
                                            <div v-html="round_colored(slotProps.data.value_profit, 4)"></div>
                                        </div>
                                    </template>
                                </Column>
                                <Column :expander="true" :headerStyle="{'width': '3rem'}" />

                                <template #expansion="slotProps">
                                    <div class="flex flex-row">
                                        <div class="flex-1 pr-4">
                                            <Card>
                                                <template #content>
                                                    <div v-if="loadingDealCandles">loading...</div>
                                                    <div v-else>
                                                        <one-deal-chart :candles="candles" :deal="expandedDeals[0]"></one-deal-chart>
                                                    </div>
                                                </template>
                                            </Card>
                                        </div>
                                        <div class="flex-1">
                                            <Card>
                                                <template #content>
                                                    <div class="text-xl mb-2">Логи</div>
                                                    <div v-if="dealLogs && filteredLogsBySelectedDeal.length > 0">
                                                        <DataTable :value="dealLogs(slotProps.data)" selectionMode="single" dataKey="id">
                                                            <Column header="Дата" >
                                                                <template #body="slotProps">
                                                                    {{timezoned(slotProps.data.date)}}
                                                                </template>
                                                            </Column>
                                                            <Column header=""  >
                                                                <template #body="slotProps">
                                                                    <span>{{slotProps.data.level}}</span>
                                                                </template>
                                                            </Column>
                                                            <Column header="Сообщение" >
                                                                <template #body="slotProps">
                                                                    <span>{{slotProps.data.message}}</span>
                                                                </template>
                                                            </Column>
                                                        </DataTable>
                                                    </div>
                                                    <div v-else>
                                                        <p>Логи отсутствуют.</p>
                                                    </div>
                                                </template>
                                            </Card>
                                        </div>
                                    </div>
                                </template>
                            </DataTable>
                            </div>
                            <div v-if="isShowAllLogs" class="flex-1 ml-4">

                                <div v-if="botResultData.logs && botResultData.logs.length > 0">
                                    <DataTable :value="botResultData.logs" selectionMode="single" dataKey="id">
                                        <Column header="Дата" >
                                            <template #body="slotProps">
                                                {{short_timezoned(slotProps.data.date)}}
                                            </template>
                                        </Column>
                                        <Column header="" field="level" ></Column>
                                        <Column header="Сообщение" >
                                            <template #body="slotProps">
                                                <span>{{slotProps.data.message}}</span>
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                                <div v-else>
                                    <p>Логи отсутствуют.</p>
                                </div>

                            </div>
                        </div>
                        <div v-else>
                            <p>Сделки отсутствуют.</p>
                        </div>

                    </template>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
import helperMethods from '@/helpers'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TradingVue from 'trading-vue-js'
import OneDealChart from "@/Charts/OneDealChart";

export default {
    props: {
        botResultData: Object,
        replayResultId: Number,
        candles: Array,
    },
    components:{
        Card, Button, DataTable, Column, TradingVue, OneDealChart
    },
    data(){
        return {
            selectedDeal: null,
            expandedDeals: [],
            isShowAllLogs: false,

            loadingDealCandles: false
        }
    },
    mounted(){
        //console.log(this.botResultData);
    },
    computed:{
        filteredLogsBySelectedDeal(){
            if(!this.selectedDeal) return this.botResultData.logs;
            return this.botResultData.logs.filter((log)=>{
                if(log.date >= this.selectedDeal.started_at && (!this.selectedDeal.completed_at || log.date <= this.selectedDeal.completed_at)){
                    return log;
                }
            });
        },
        selectedChartData(){
            if(!this.selectedDeal) return false;
            if(!this.candles) return false;
            return { ohlcv: this.candles.map((candle)=> {
                    return [
                        candle.open_time, parseFloat(candle.open), parseFloat(candle.high), parseFloat(candle.low), parseFloat(candle.close), 0
                    ]
                })
            };
        },
        allDeals(){
            return [...this.botResultData.openDeals, ...this.botResultData.closedDeals];
        },
        countLogs(){
            return this.botResultData.logs ? this.botResultData.logs.length : "0";
        },

    },
    methods:{
        ...helperMethods,

        dealLogs(deal){
            return this.botResultData.logs.filter((log)=>{
                if(log.date >= deal.started_at && (!deal.completed_at || log.date <= deal.completed_at)){
                    return log;
                }
            });
        },

        onDealSelect(event){
            this.selectedDeal = event.data;

        },

        onDealExpand(event){
            this.expandedDeals = [];
            this.expandedDeals.push(event.data)
        },
    }
}
</script>


